import React, { FunctionComponent, ReactNode } from 'react';

import { Text } from '@yandex-360/orb-components/dist/components/Text';
import cn from 'classnames';

import styles from './styles.css';

type ArtifactProps = {
    title: string;
    subTitle?: string;
    children: ReactNode;
    className?: string;
};

export const Artifact: FunctionComponent<ArtifactProps> = ({ title, subTitle, children, className }) => {
    return (
        <div className={cn(styles.artifact, className)}>
            <div className={styles.left}>
                <Text typography="body-md-regular">{title}</Text>
                {subTitle && (
                    <Text typography="caption-md-regular" color="secondary">
                        {subTitle}
                    </Text>
                )}
            </div>
            {children}
        </div>
    );
};
